import { render } from "./ViewMediaFileMoreMovie.vue?vue&type=template&id=57473ed0&scoped=true"
import script from "./ViewMediaFileMoreMovie.vue?vue&type=script&lang=js"
export * from "./ViewMediaFileMoreMovie.vue?vue&type=script&lang=js"

import "./ViewMediaFileMoreMovie.vue?vue&type=style&index=0&id=57473ed0&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-57473ed0"

export default script